import { AsyncPipe, NgClass, UpperCasePipe, KeyValuePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, viewChild } from '@angular/core';

import { NbButtonModule, NbIconModule, NbListModule, NbPopoverDirective, NbPopoverModule } from '@nebular/theme';
import SenetIdUniversalClass from '@senet-id/universal';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageCode } from '@senet-uiverse/i18n';
import { map } from 'rxjs/operators';

@Component({
  selector: 'sid-language',
  templateUrl: './language.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgClass,
    AsyncPipe,
    NbIconModule,
    NbListModule,
    KeyValuePipe,
    UpperCasePipe,
    NbButtonModule,
    NbPopoverModule,
    TranslateModule,
  ],
})
export class LanguageComponent extends SenetIdUniversalClass {
  private readonly popoverEl = viewChild.required(NbPopoverDirective);

  protected readonly uiCurrentLang$ = this.i18nService.getCurrentLanguage().pipe(map((lang) => lang.code2));
  protected readonly uiAvailableLanguages = this.i18nService.langs;

  protected changeLang(localeId: Readonly<LanguageCode>) {
    this.i18nService.setLocale(localeId);
    this.popoverEl().hide();
  }
}
